import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import brLocale from "date-fns/locale/pt-BR";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2, 0),
        width: '100%',
    },
}));

export const DatePickerSimple = (props) => {
    const classes = useStyles();

    return (
        <FormControl className={classes.formControl}>
            <TextField
                type="date-local"
                InputLabelProps={{
                    shrink: true,
                }}
                {...props}
            />
        </FormControl>
    );
}

export const DatePicker = (props) => {
    const classes = useStyles();
    
    const localeMap = {
        br: brLocale,   
    }

    return (
        <FormControl className={classes.formControl}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["br"]}>
                <KeyboardDatePicker
                    ampm={false}
                    clearLabel="Limpar"
                    cancelLabel="Cancelar"
                    okLabel="Salvar"
                    todayLabel="Agora"
                    format={"dd/MM/yyyy"}
                    KeyboardButtonProps={{ 'aria-label': 'Selecione a Data', 'color': 'primary' }}
                    {...props}
                    onChange={(e) => props.onChange(e)}
                    allowKeyboardControl
                    invalidDateMessage={props.value ? "Formato de Data Inválido" : ""}
                    invalidLabel={props.value ? "Data Inválida" : ""}
                    mask={"__/__/____"}
                />
            </MuiPickersUtilsProvider>
        </FormControl>
    );
}

export default DatePicker;